const activeView = 'ACTIVE_VIEW';

export default {
  activeView
};
